<script lang="ts">
	import { userMarginList } from '$lib/home/userInteract/store';
	import { openAdjustMarginModal } from '$lib/home/userInteract/userInteract';
	import { getDisplayName, getTokenLogo } from '$lib/perps';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import type { MarketIdentifiers } from '$lib/types/market';
	import { getNumBackInUnits } from '$lib/util/util';
	import BigNumber from 'bignumber.js';

	export let market: MarketIdentifiers;
	export let balance: string;

	function getUserMargin(marketId: MarketIdentifiers) {
		if ($userMarginList) {
			// from getUserMargin return the depositedMargin for the markerId
			let depositedMargin = $userMarginList.find((margin) => margin?.marketIdentifier == marketId)
				?.depositedMargin as string;
			if (depositedMargin) return getNumBackInUnits(depositedMargin, 18, 2);
		}
		return '';
	}

	function getUserAccessibleMargin(marketId: MarketIdentifiers) {
		if ($userMarginList) {
			// from getUserMargin return the depositedMargin for the markerId
			let accessibleMargin = $userMarginList.find((margin) => margin?.marketIdentifier == marketId)
				?.accessibleMargin as string;
			if (accessibleMargin) return getNumBackInUnits(accessibleMargin, 18, 2);
		}
		return '';
	}
</script>

<div class="flex justify-between items-center bg-fx-grey-800 p-2 rounded-lg squircle-lg">
	<div class="flex gap-1">
		<img src={getTokenLogo(market)} loading="lazy" alt="token" class="w-7 h-7" />
		<div>
			<p class="text-sm text-fx-grey-100 font-medium">{getDisplayName(market)}</p>
			<div class="flex gap-1">
				<p class="text-fx-grey-300 text-xs font-normal">Balance:</p>
				<p class="text-fx-blue text-xs font-medium">{balance}</p>
				{#if market}
					{#if new BigNumber(getUserAccessibleMargin(market)).isEqualTo(getUserMargin(market)) && !new BigNumber(getUserMargin(market)).isZero()}
						<span class="text-fx-grey-400 text-xs font-medium"> (No Position) </span>
					{/if}
				{:else}
					<div
						class="animate-pulse bg-fx-grey-800 h-4 col-span-2 rounded-lg squircle-lg w-6 mx-auto"
					/>
				{/if}
			</div>
		</div>
	</div>
	<Tooltip header="Current Margins" title="These are margins that don't have any active positions">
		<button
			on:click={() => {
				openAdjustMarginModal(market, 'Deposit');
			}}
			on:keydown={() => {
				openAdjustMarginModal(market, 'Deposit');
			}}
		>
			<img
				src={'new_sc_wallet/up_down_arrow.svg'}
				loading="lazy"
				alt="new_sc_wallet/up_down_arrow.svg"
			/>
		</button>
	</Tooltip>
</div>
